import React from "react";
import MediaHub from "../../../images/home-page/MediaHub-Thumbnail.jpg";
import SpottedOnSite from "../../../images/home-page/SpottedOnSite-Thumnail.jpg";
import NcImage from "shared/NcImage/NcImage";
import ButtonCSCLed from "shared/Button/ButtonCSCLed";

const products = [
  {
    id: 1,
    name: "Media Hub",
    description: `Your one-stop destination for the latest articles, press releases,
videos, Spotted On Site series, and more. Find all the stories, updates,
and insights about our products and projects in one convenient place.`,
    imageSrc: MediaHub,
    imageAlt: "Media Hub",
  },
  {
    id: 2,
    name: "Spotted On Site",
    href: "#",
    price: "$32",
    description: `Explore our products in action through our 'Spotted On Site' series. See
how our products are shaping brighter, safer, and more energy-efficient
spaces—driven by innovation and built for the real world.`,
    imageSrc: SpottedOnSite,
    imageAlt: "Spotted On Site",
  },
];

const HomePageMediaHub = () => {
  return (
    <div className="nc-HomePageMediaHub py-20 px-4 lg:px-16 xl:px-32 bg-stone-100">
      <div className="">
        <h2 className="sr-only">Products</h2>

        <div className="grid grid-cols-1 gap-y-4 lg:grid-cols-2 sm:gap-x-6 sm:gap-y-10 lg:gap-x-20">
          {products.map((product) => (
            <div
              key={product.id}
              className="group relative flex flex-col overflow-hidden rounded-xl border border-gray-200 bg-white"
            >
              <NcImage
                alt={product.imageAlt}
                src={product.imageSrc}
                containerClassName="w-full bg-gray-200 group-hover:opacity-75 h-60 sm:h-80 lg:h-64 xl:h-80 shadow-xl"
                className="w-full h-full object-cover"
              />
              <div className="flex flex-1 flex-col !p-5">
                <h2
                  className={`font-semibold text-lg sm:text-2xl text-csccolor`}
                >
                  {product.name}
                </h2>
                <p className={`text-sm sm:text-base dark:text-slate-400 mt-1 `}>
                  {product.description}
                </p>
                <div className="mt-auto pb-2 pt-4">
                  <ButtonCSCLed className="">Coming Soon</ButtonCSCLed>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HomePageMediaHub;
